/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 jQuery(document).ready(function(){
  headerFix();
  $(window).scroll(function(){
      headerFix();
  });

  var temp = $(window).scrollTop();
  // console.log(temp);
  var headerHeight = 0;
  var headerHeightBoxShadow = 200;
  function headerFix(){
      var $windowTop = $(window).scrollTop();
      var $header = $('.Header');

      if($windowTop > headerHeight){
          $header.addClass('is-sticky');
      }else{
          $header.removeClass('is-sticky');
      }
      
      if($windowTop > headerHeightBoxShadow){
        $header.addClass('is-box-shadow');
      }else{
        $header.removeClass('is-box-shadow');
      }
      temp = $windowTop;
  }

});


$(document).ready(function() {

  $('.ProductAccordition').on('click', '.ProductAccordition__Title', function(e) {
      e.preventDefault();
      $(this).toggleClass('Is-Active');
      $(this).next().slideToggle();
  });


});

var $gallery = $('.Product__GalleryTop--Slider');
var slideCount = null;

$( document ).ready(function() {
  $gallery.slick({
    infinite: true,
    draggable: true,
    fade: false,
    cssEase: 'linear',
    nextArrow: ".Product__GalleryTop--Arrow--Next",
    prevArrow: ".Product__GalleryTop--Arrow--Prev",
    centerMode: true,
    slidesToShow: 1,
    speed: 500,
    variableWidth: true,
    responsive: [
      {
          breakpoint: 768,
              settings: {
                  variableWidth: false,
                  centerMode: false,
                  draggable: true,
                  infinite: false,
                  slidesToShow: 1
              }
      }
    ]
  });
});

$gallery.on('init', function(event, slick){
slideCount = slick.slideCount;
setSlideCount(slick.currentSlide);
setCurrentSlideNumber(slick.currentSlide);
});

$gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
setCurrentSlideNumber(nextSlide);
setSlideCount(nextSlide);
});

function setSlideCount(currentSlide) {
var $el = $('.Product__GalleryTop--Arrow--Number').find('.Total');
$el.text(slideCount);
var currentSlide = currentSlide + 1;
//   console.log(currentSlide);
if(slideCount == currentSlide) {
  $('.Product__GalleryTop--Arrow--Next').addClass('slick-disabled');
} else {
  $('.Product__GalleryTop--Arrow--Next.slick-disabled').removeClass('slick-disabled');
}
}

function setCurrentSlideNumber(currentSlide) {
var $el = $('.Product__GalleryTop--Arrow--Number').find('.Current');
$el.text(currentSlide + 1);
if(currentSlide == 0) {
  $('.Product__GalleryTop--Arrow--Prev').addClass('slick-disabled');
} else {
  $('.Product__GalleryTop--Arrow--Prev.slick-disabled').removeClass('slick-disabled');
}
}

$('.Product-Custom .ProductService02__Select select').change(function(){
  $(this).css('opacity','1');
})


// $(window).on('load', function () {
//   $('.hulkapps_option_value .hulkapps_radio_option:first-child .radio_div').addClass('radio_selected');
// });